import type {Customer} from "@/components/customers/scripts/types";
import {createEmptyCustomer} from "@/components/customers/scripts/customerActions";
import { getNumberItemFromStorage } from "@/scripts/Common/componentStorage";
import { CUSTOMER_ID_STORAGE_KEY } from "./constants";
import { fetchCustomer, fetchCustomers } from "./customerApiRequests";

const fetchFirstCustomer = async () => {
  const {error, response} = await fetchCustomers({pageSize: 1});

  return {error, response: response?.[0]};
}


// Tries to load customer from storage if available. If not it will load the first customer from the list of customers
// If overrideId > 0, skips storage and loads directly by that ID
const loadCustomerFromStorageOrFirst = async (overrideId?: number): Promise<{ error?: any, response?: Customer }> => {
  if (overrideId && overrideId > 0) {
    return fetchCustomer(overrideId);
  }

  const customerId = getNumberItemFromStorage(CUSTOMER_ID_STORAGE_KEY);

  if(!customerId){
    return fetchFirstCustomer();
  }

  const { error, response } = await fetchCustomer(customerId);

  // no customer found in storage or customer does not exist anymore, load first customer from list of all customers
  if(error){
    return fetchFirstCustomer();
  }

  return {error, response};
}



export {
   loadCustomerFromStorageOrFirst
}
